import { useEffect, useRef } from 'react'

/**
 * The {@link useVariableRef} hook creates a reference object that updates its
 * stored value each time the passed `value` changes.
 *
 * @usage
 * ```
 *  const valueRef = useVariableRef(value)
 * ```
 *
 * @note
 * The `valueRef` object will not change during component life-cycle,
 * so it can be safely added to effects / callbacks dependencies.
 *
 * @template {*} TValue
 *
 * @param {TValue} value
 *
 * @returns React.RefObject<TValue>
 */
export function useVariableRef(value) {
  const propsRef = useRef(value)

  useEffect(() => {
    propsRef.current = value
  }, [value])

  return propsRef
}
